import BrickbatWebSDK, {
	BrickbatAPI,
	BrickbatConfig,
} from '@phonepe/brickbat-web-sdk';
import { v4 as uuidv4 } from 'uuid';
import { get } from 'lodash';

import { store } from '@/redux/store/store';

import Api from '../data/index';
import constants from './constants';

const {
	BRICKBAT_SURVEY_LINK,
	API_WEB_BASE_URL,
	SUB_URL_BRICKBAT,
	BRICKBAT_SURVEY_NAMESPACE,
} = constants;

class BrickbatUtility {
	private static survey: BrickbatAPI;

	static openSurvey(
		campaignId: string,
		successHandler: () => void,
		failureHandler: () => void,
	): void {
		if (BrickbatUtility?.survey?.isOpen()) {
			return;
		}
		const rootStore = store?.getState();
		BrickbatUtility.survey = BrickbatWebSDK({
			height: '500px',
			width: '400px',
			backdrop: false,
			position: { right: '10px', bottom: '10px' },
			postBaseUrl: `${API_WEB_BASE_URL}${SUB_URL_BRICKBAT}`,
			campaignUrl: BRICKBAT_SURVEY_LINK.replace('CAMPAIGN_ID', campaignId),
			namespace: BRICKBAT_SURVEY_NAMESPACE,
			userId: get(rootStore, 'merchantProfile.merchantDetails.merchantId', ''),
			clientId: uuidv4(),
			axiosInstance: Api.apiWebClient.getAxiosInstance(),
			version: 1,
			context: {},
			successHandler,
			failureHandler,
		} as BrickbatConfig).init();
		BrickbatUtility.survey.open();
	}
}

export default BrickbatUtility;
